
export const getDefaultState = () => {
  return {
    aggregationData: null,
    tagTotal: null,
  };
};
export const state = getDefaultState();
